import { STATUS } from "@/constants/statuses";
import { OffsetPaginationMetaEntity } from "@/entities/OffsetPaginationEntity";
import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { produce } from "immer";
import { injectable } from "tsyringe";

import ReviewEntity from "../entities/ReviewEntity";

export interface ReviewsStateBase
    extends EntityState<ReviewEntity, string>,
        ActiveState {
    paginationMeta: OffsetPaginationMetaEntity;
    status: STATUS;
    updateReviewStatus: STATUS;
    updateReviewError: Error | null;
}

function createInitialState(): ReviewsStateBase {
    return {
        active: null,
        paginationMeta: {
            perPage: 0,
            totalCount: 0,
            currentOffset: 0,
        },
        status: STATUS.VIRGIN,
        updateReviewStatus: STATUS.VIRGIN,
        updateReviewError: null,
    };
}

@injectable()
@StoreConfig({ name: "reviewsStoreBase", producerFn: produce, idKey: "uid" })
class ReviewsStoreBase extends EntityStore<ReviewsStateBase> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS) {
        this.update(() => ({
            status: status,
        }));
    }

    getStatus(): STATUS {
        return this.getValue().status;
    }

    // Update review status
    setUpdateReviewStatus(status: STATUS) {
        this.update(() => ({
            updateReviewStatus: status,
        }));
    }
    setUpdateReviewError(error: Error | null) {
        this.update(() => ({
            updateReviewError: error,
        }));
    }

    getUpdateReviewStatus(): STATUS {
        return this.getValue().updateReviewStatus;
    }
}

export default ReviewsStoreBase;
